const AlertRoot = 'alerts';

export const alertsPaths = {
  root: AlertRoot,
  new: `${AlertRoot}/new`,
  edit: `${AlertRoot}/:alertId/edit`,
};
